<!--
 * @Author: Shber
 * @Date: 2022-03-08 16:49:02
 * @LastEditors: Shber
 * @LastEditTime: 2023-06-14 17:20:26
 * @Description:
-->
<template>
  <div class="filed_line">
    <van-field
      v-model="typeText"
      :is-link="!isReadonly"
      readonly
      :name="$t('auth.opnAuth.userText1')"
      :label="$t('auth.opnAuth.userText1')"
      :placeholder="$t('auth.opnAuth.userText1')"
      @click="popupShowFn"
    />
    <van-action-sheet
      :show="popupShow"
      :round="false"
      :actions="typeInfo"
      :cancel-text="$t('auth.aiAuth.cancel')"
      close-on-click-action
      @select="onSelect"
      @cancel="onCancel"
    />
  </div>
</template>
<script setup>
import { defineProps, watch, computed, ref, reactive } from 'vue'
import { ActionSheet as vanActionSheet, Field as vanField } from 'vant'
import { useI18n } from 'vue-i18n/index'// 要在js中使用国际化
const { t } = useI18n() // 国际化方法

const emits = defineEmits(['getCardType'])
const props = defineProps({
  cardType: {
    type: String,
    default: ''
  },
  readonly: {
    type: Boolean,
    default: false
  }
})

const isReadonly = computed(() => props.readonly)
const typeText = computed(() => {
  // 1: '大陆',
  // 2: '港澳台',
  // 3: '海外,
  switch (cardTypeId.value) {
    case '2':
      return t('auth.opnAuth.userText3')
    case '3':
      return t('auth.opnAuth.userText4')
    default:
      return t('auth.opnAuth.userText2')
  }
})

const cardTypeId = ref('')
const popupShow = ref(false)
const typeInfo = reactive([
  { name: t('auth.opnAuth.userText2'), val: '1' },
  { name: t('auth.opnAuth.userText3'), val: '2' },
  { name: t('auth.opnAuth.userText4'), val: '3' }
])

watch(() => props.cardType,
  (newVal, oldVal) => {
    cardTypeId.value = newVal
  },
  { immediate: true })

const onCancel = () => { popupShow.value = false }
const onSelect = (action, index) => {
  cardTypeId.value = action.val
  emits('getCardType', action)
  popupShow.value = false
}
const popupShowFn = () => {
  if (isReadonly.value) { return false }
  popupShow.value = true
}

</script>
<style lang="scss" scoped>
.filed_line{
  position: relative;
  &::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 16px;
    bottom: 0;
    left: 16px;
    border-bottom: 1px solid #ebedf0;
    transform: scaleY(0.5);
  }
}
</style>
